import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import doctorIcon from "../../assets/images/Svg/doctorIcon.svg";
import { useSearchParams } from "react-router-dom";
import doctor from "../../assets/images/Svg/doctor.svg";
import { MdLocationOn, MdOutlinePhone } from "react-icons/md";
import {
  Drawer,
  Flex,
  message,
  Modal,
  Select,
  Spin,
  Tooltip,
  Pagination,
} from "antd";
import { IoCloseCircle, IoSearch } from "react-icons/io5";
import UserService from "../../Services/UserService";
import nodatafound from "../../assets/images/Svg/nodatafound.svg";
import { FiMapPin } from "react-icons/fi";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import Layout from "../../Layout";
import SideDrawer from "./SideDrawer";
import { useSelector } from "react-redux";
import RequestApptDrawer from "./RequestApptDrawer";

function ConsultDoctor() {
  const patientData = useSelector((state) => state.auth.patientData);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [doctorSpecialties, setDoctorSpecialties] = useState([]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [referralId, setReferId] = useState(searchParams.get("referralId"));
  const [referData, setReferData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const pincodeFromSession = sessionStorage.getItem("availPin");
  const [availPincode, setAvailPincode] = useState(
    pincodeFromSession ? pincodeFromSession : "",
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(9);
  const [hasMore, setHasMore] = useState(true);
  const [apiPayload, setApiPayload] = useState({});
  const [userType, setUserType] = useState("All");
  const [videoConsultDoctors, setVideoConsultDoctors] = useState([]);

  const getDoctorsListForVideo = async () => {
    let payload = {
      displayInWebsite: "Y",
      status: 1,
      pageNo: currentPage,
      pageSize: pageSize,
    };

    setIsLoading(true);
    try {
      const response = await UserService.getDoctors(payload);
      setVideoConsultDoctors(response?.data);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (availPincode) {
      getDoctorsListForVideo();
    }
  }, [availPincode]);

  const onTypeChage = async (type) => {
    if (type == "All") {
      setUserType("All");
      getDoctorsList(null, 1);
    } else {
      let payload = {
        userType: type,
      };
      getDoctorsList(payload, 1);
      setUserType(type);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (referralId) {
      getreferalDeatails();
    } else {
      getDoctorsList();
      getSpecialities();
    }
  }, []);

  useEffect(() => {
    if (referData.length > 0) {
      getDoctorsList();
      getSpecialities();
    }
  }, [referData]);

  const handlePageChange = (page, size = 9) => {
    const updatedPayload = {
      ...apiPayload,
      pageNo: page,
      pageSize: size,
    };
    setApiPayload(updatedPayload);

    UserService.getDoctors(updatedPayload)
      .then((result) => {
        setDoctors(result?.data || []);
        setHasMore((result?.data || []).length === size);
        setCurrentPage(page);
        setPageSize(size);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getDoctorsList = async (filterPayload, page = 1) => {
    const userPayload = filterPayload
      ? {
          ...filterPayload,
          displayInWebsite: "Y",
          status: 1,
          pageNo: page,
          pageSize: pageSize,
        }
      : {
          displayInWebsite: "Y",
          status: 1,
          pageNo: page,
          pageSize: pageSize,
        };
    if (referralId) {
      userPayload.userId = referData[0].referTo;
    }
    setApiPayload(userPayload);
    setIsLoading(true);
    try {
      const response = await UserService.getDoctors(userPayload);
      setDoctors(response?.data || []);
      setHasMore((response?.data || []).length === pageSize);
      setCurrentPage(page);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };

  const getreferalDeatails = async () => {
    const userPayload = {
      referralId: referralId,
    };

    setIsLoading(true);
    try {
      const response = await UserService.getReferal(userPayload);
      setReferData(response.data.data);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };

  const getSpecialities = async () => {
    let payload = {
      status: 1,
    };
    try {
      const response = await UserService.getDoctorSpeciality(payload);
      if (response) {
        setDoctorSpecialties(response.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleDoctorDetailsPage = (doctor) => {
    if (referralId) {
      doctor.referralId = referralId;
    }
    navigate(APP_ROUTES.DOCTORDETAILS, {
      state: { selectedDoctor: doctor, availPincode: availPincode },
    });
  };

  const showDrawer = (doctor) => {
    setSelectedDoctor(doctor);
    setIsDrawerVisible(true);
  };

  const closeDrawer = () => {
    setIsDrawerVisible(false);
  };

  const DoctorCard = ({ doctor, key }) => (
    <div className="p-5 sm:p-2 bg-white shadow-md border rounded-lg relative">
      <div className="bg-primaryColor text-white absolute top-0 right-0 text-sm rounded-tr-md px-4 rounded-bl-md">
        {doctor?.userType == "P"
          ? "Doctor"
          : doctor?.userType == "PT"
            ? "Physio"
            : doctor?.userType == "N"
              ? "Nurse"
              : ""}
      </div>
      <div key={key} className="flex gap-4">
        <div className="w-[90px] sm:w-[80px] h-[90px] sm:h-[80px] rounded-lg overflow-hidden flex-shrink-0 bg-slate-50 border border-gray-100 flex items-center justify-center">
          <img
            src={
              doctor.imageName
                ? `${process.env.REACT_APP_IMAGE_URL}${doctor.imageName}`
                : doctorIcon
            }
            alt={doctor?.firstName}
            className={`w-full h-full cursor-pointer ${
              doctor.imageName ? "object-cover" : "object-contain p-2"
            }`}
            onClick={() => handleDoctorDetailsPage(doctor)}
          />
        </div>

        <div className="flex flex-col flex-grow justify-between">
          <div>
            <Tooltip
              title={`${doctor?.salutation || ""} ${doctor?.firstName || ""} ${doctor?.lastName || ""}`.trim()}
            >
              <h2 className="text-lg sm:text-sm font-semibold text-blue-800 truncate">
                {`${doctor?.salutation || ""} ${doctor?.firstName || ""} ${doctor?.lastName || ""}`.trim()}
              </h2>
            </Tooltip>
            {doctor.speciality && (
              <p className="text-sm  bg-[#D7EAFF] w-fit py-0.5 px-1 rounded mt-1">
                {doctor.speciality}
              </p>
            )}
            <p className="text-sm text-gray-600 mt-1">{doctor.qualification}</p>
            {doctor?.city && (
              <div className="flex items-center text-sm text-gray-600 mt-1">
                <MdLocationOn className="w-4 h-4 mr-1 text-[#189FAA]" />
                <p>{doctor?.city}</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-between mt-4 sm:mt-2">
        <button
          onClick={() => handleDoctorDetailsPage(doctor)}
          className="text-sm text-black underline "
        >
          View Profile
        </button>

        <div className="flex items-center gap-3 sm:flex justify-between">
          <p className="text-lg sm:text-sm font-semibold text-gray-900">
            {doctor.videoFee > 0 ? `₹ ${doctor.videoFee}` : "Free "}
          </p>
          {doctor?.appointmentType == "REQUEST" ? (
            <button
              onClick={() => showDrawer(doctor)}
              className="bg-[#189FAA] text-white text-sm px-4 py-1.5 rounded hover:bg-[#127d8d] disabled:opacity-50 transition"
            >
              Request appointment
            </button>
          ) : (
            <button
              onClick={() => showDrawer(doctor)}
              className="bg-[#189FAA] text-white text-sm sm:text-xs px-4 py-1.5 rounded hover:bg-[#127d8d] disabled:opacity-50 transition"
            >
              Book appointment
            </button>
          )}
        </div>
      </div>
    </div>
  );

  const handleSpecialityChange = async (code) => {
    setDoctors([]);
    if (code) {
      const payload = {
        specialityCode: code,
      };
      getDoctorsList(payload, 1);
    } else {
      getDoctorsList(null, 1);
    }
  };

  const handleSearchDoc = async (searchText) => {
    setDoctors([]);
    if (searchText && searchText.trim() !== "") {
      const payload = {
        firstName: searchText.trim(),
        // lastName: searchText.trim(),
      };
      getDoctorsList(payload, 1);
    } else {
      getDoctorsList(null, 1);
    }
  };

  const checkAvail = () => {
    const pincode = pincodeRef.current.value;
    if (pincode === "" || pincode.length > 7) {
      message.error("Enter Valid Pincode to search Doctors");
      setAvailPincode("");
      return;
    } else {
      sessionStorage.setItem("availPin", pincode);
      setAvailPincode(pincode);
      let payload = {
        clinicPincode: pincode,
      };
      getDoctorsList(payload, 1);
      handleCancel();
    }
  };

  const handleViewAll = async () => {
    setAvailPincode("");
    sessionStorage.setItem("availPin", "");
    const userPayload = { displayInWebsite: "Y", status: 1 };
    setIsLoading(true);
    getDoctorsList(userPayload, 1);
  };
  const pincodeRef = useRef();

  return (
    <>
      <Layout>
        {isModalOpen && (
          <Modal
            title="Enter Pincode"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[]}
          >
            <div className="flex items-center space-x-2 mt-3">
              <input
                ref={pincodeRef}
                type="text"
                placeholder="Enter an pincode"
                className="flex-1 border border-gray-300 rounded p-2 text-sm outline-none"
              />
              <button
                onClick={checkAvail}
                className="px-4 py-2 text-sm rounded-full bg-green-500 font-Poppins text-white"
              >
                Apply
              </button>
            </div>
          </Modal>
        )}

        <div className="max-w-7xl mx-auto px-4 mt-6">
          {" "}
          <div className="flex flex-wrap items-center justify-between gap-3 p-3 sm:p-4 border border-[#CDE0E2] bg-gradient-to-r from-[#e6f9f6] to-[#f4fdfc] rounded-lg w-full">
            {" "}
            <div className="p-5">
              <h2 className="text-base sm:text-sm text-xl font-medium text-gray-800">
                {" "}
                Get expert advice from
                <span className="text-teal-600 font-semibold">
                  certified <br></br> doctors{" "}
                </span>
                anytime, anywhere.
              </h2>
              <div className=" md:flex">
                <p className="text-sm mt-3 gap-4">
                  Contact us for healthcare services
                </p>
                <div className="mt-2  ml-2 flex items-center space-x-2 border px-4 py-1 rounded-md border-gray-300 w-max bg-white shadow-sm">
                  <MdOutlinePhone className="text-[#189FAA]" />
                  <span className="text-sm font-semibold">Call</span>
                  <span className="text-sm font-semibold">+91 90256 33829</span>
                </div>
              </div>
            </div>
            <div className="mr-3">
              <img src={doctor} alt="" className="" />
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-3 sm:gap-5 mt-5">
            <div className="flex items-center border justify-between border-gray-300 rounded-lg overflow-hidden">
              <Tooltip placement="bottom" title={"Select Location"}>
                <div
                  onClick={showModal}
                  className="flex items-center gap-1 px-3 cursor-pointer"
                >
                  <FiMapPin className=" text-green-500" />
                  <span className="px-1 py-2 bg-white text-gray-700 focus:outline-none cursor-pointer">
                    {availPincode ? availPincode : ""}
                  </span>
                </div>
              </Tooltip>
              {availPincode ? (
                <IoCloseCircle
                  onClick={handleViewAll}
                  className="text-xl text-gray-500 cursor-pointer mr-2"
                />
              ) : (
                ""
              )}
              <div className="relative ">
                <input
                  type="text"
                  placeholder="Search doctor names"
                  className="px-3 py-2 w-64 sm:w-full outline-none bg-[#FAFFFD] border-[#C1DFE1]"
                  onChange={(e) => handleSearchDoc(e.target.value)}
                />
                <div className="absolute inset-y-1 right-1 flex justify-end">
                  <button
                    type="submit"
                    className="bg-[#189FAA] text-white px-3 py-2"
                  >
                    <IoSearch />
                  </button>
                </div>
              </div>
            </div>
            <div className="w-[25%] sm:w-full">
              <Select
                className=" rounded-lg custom-select-bg w-full h-10 bg-[#FAFFFD] border-[#C1DFE1]"
                placeholder="Speciality"
                allowClear
                showSearch
                onChange={handleSpecialityChange}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={doctorSpecialties?.map((spec) => {
                  return {
                    label: spec.speciality,
                    value: spec.code,
                  };
                })}
              />
            </div>
            <div className="flex flex-wrap gap-2">
              <span
                onClick={() => onTypeChage("All")}
                className={`cursor-pointer text-xs sm:text-sm px-2 py-1 border rounded-md ${
                  userType == "All" ? "bg-primaryColor text-white" : ""
                }`}
              >
                All
              </span>
              <span
                onClick={() => onTypeChage("P")}
                className={`cursor-pointer text-xs sm:text-sm px-2 py-1 border rounded-md ${
                  userType == "P" ? "bg-primaryColor text-white" : ""
                }`}
              >
                Doctor
              </span>
              <span
                onClick={() => onTypeChage("N")}
                className={`cursor-pointer text-xs sm:text-sm px-2 py-1 border rounded-md ${
                  userType == "N" ? "bg-primaryColor text-white" : ""
                }`}
              >
                Nurse
              </span>
              <span
                onClick={() => onTypeChage("PT")}
                className={`cursor-pointer text-xs sm:text-sm px-2 py-1 border rounded-md ${
                  userType == "PT" ? "bg-primaryColor text-white" : ""
                }`}
              >
                Physiotherapist
              </span>
            </div>

            {availPincode && (
              <div className="gap-5">
                <button
                  className="bg-white px-4 py-2 rounded-md border border-[#189FAA]"
                  onClick={handleViewAll}
                >
                  View All
                </button>
              </div>
            )}
          </div>
          <div>
            {isLoading ? (
              <div className="flex items-center justify-center mt-[10%]">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading" />
                </Flex>
              </div>
            ) : !isLoading && doctors?.length !== 0 ? (
              <div className="grid grid-cols-3 sm:grid-cols-1 md:grid-cols-2 gap-4 mt-5">
                {doctors.map((doctor, index) => (
                  <DoctorCard key={index} doctor={doctor} />
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center">
                <img
                  src={nodatafound}
                  alt="nodatafound"
                  className="h-min w-min"
                />
                <p className="font-medium text-xl">No data found!!</p>
              </div>
            )}
          </div>
          {doctors.length > 0 && !(currentPage === 1 && !hasMore) && (
            <div className="flex justify-end items-center my-10">
              <Pagination
                align="end"
                current={currentPage}
                total={
                  hasMore ? currentPage * pageSize + 1 : currentPage * pageSize
                }
                pageSize={pageSize}
                onChange={handlePageChange}
                showSizeChanger={false}
              />
            </div>
          )}
          {availPincode && (
            <div className="flex flex-col my-10">
              <div className="mt-4 mb-6 text-xl font-semibold text-primaryColor">
                Doctors Available for Video Consultation
              </div>
              <div>
                <div className="grid grid-cols-3 gap-4 mt-5">
                  {videoConsultDoctors.map((doctor, index) => (
                    <DoctorCard key={index} doctor={doctor} />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        <Drawer
          title={
            <span className="font-bold text-lg text-center p-2 flex justify-center">
              Schedule Appointment
            </span>
          }
          placement="right"
          width={500}
          onClose={closeDrawer}
          open={isDrawerVisible}
          destroyOnClose
        >
          {selectedDoctor?.appointmentType !== "REQUEST" && (
            <SideDrawer
              selectedDoctor={selectedDoctor}
              referralId={referralId}
              closeDrawer={closeDrawer}
            />
          )}

          {selectedDoctor?.appointmentType === "REQUEST" && (
            <RequestApptDrawer
              selectedDoctor={selectedDoctor}
              referralId={referralId}
              closeDrawer={closeDrawer}
            />
          )}
        </Drawer>
      </Layout>
    </>
  );
}

export default ConsultDoctor;
